"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconComplete = function IconComplete(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconComplete', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1.313a5.688 5.688 0 1 0 0 11.375A5.688 5.688 0 0 0 8 2.312zm3.127 2.906c.143 0 .28.057.38.158a.535.535 0 0 1 0 .786L7.14 10.53a.535.535 0 0 1-.76 0L4.327 8.475a.547.547 0 0 1 .76-.787l1.674 1.68 3.986-3.991a.535.535 0 0 1 .38-.158z"
  }));
};

var _default = IconComplete;
exports.default = _default;